// Auto Map — symbol→underlying mapping. Routes under /api/app/auto-map (verified).
export interface AutoMapDto {
  id: string; // composite Base-Quote-BaseAssetClassId-QuoteAssetClassId
  mapped: boolean;
  underlying: string; // display name or "-"
  symbols: string; // pipe-separated
  underlyingId: string | null;
}

export interface UpdateAutoMapDto {
  id: string;
  underlyingId: string; // empty GUID when unmapped
  mapped: boolean;
  symbols: string;
}

export interface UnderlyingDto {
  id: string;
  name: string;
}

export interface AutoMapRequest {
  skipCount?: number;
  maxResultCount?: number;
}

export interface PaginatedOutput<T> {
  items: T[];
  totalCount: number;
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
